var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.979,
    height: 25.867,
    viewBox: "0 0 33.979 25.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.029)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.833 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.574,1.887v-.76a1.1,1.1,0,0,1,1.1-1.1L27.151,0l-.03,0h0L1.1.025A1.1,1.1,0,0,0,0,1.127v.76A2.761,2.761,0,0,0,2.444,3.312,2.871,2.871,0,0,0,3.232,3.2,2.755,2.755,0,0,1,1.574,1.887Z",
    transform: "translate(0.045 0.047)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.206.255a.472.472,0,0,0-.839,0A2.9,2.9,0,0,1,0,.8a2.758,2.758,0,0,0,2.129.972,2.885,2.885,0,0,0,.787-.108A2.762,2.762,0,0,1,1.206.255Z",
    transform: "translate(6.193 1.584)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.206.254a.472.472,0,0,0-.839,0A2.9,2.9,0,0,1,0,.8a2.758,2.758,0,0,0,2.13.974,2.875,2.875,0,0,0,.785-.109A2.765,2.765,0,0,1,1.206.254Z",
    transform: "translate(23.693 1.584)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.207.255A.472.472,0,0,0,.787,0h0a.473.473,0,0,0-.42.256A2.9,2.9,0,0,1,0,.8a2.758,2.758,0,0,0,2.13.973,2.887,2.887,0,0,0,.787-.108A2.763,2.763,0,0,1,1.207.255Z",
    transform: "translate(17.859 1.584)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.207.256,1.2.234A.472.472,0,0,0,.368.255,2.912,2.912,0,0,1,0,.8a2.757,2.757,0,0,0,2.13.973,2.885,2.885,0,0,0,.787-.108A2.762,2.762,0,0,1,1.207.256Z",
    transform: "translate(12.025 1.584)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.787,1.388a3.75,3.75,0,0,0,2.13-.66A3.733,3.733,0,0,1,2.13,0,3.733,3.733,0,0,1,0,1.3a3.786,3.786,0,0,0,.787.084Z",
    transform: "translate(20.775 2.916)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.787,1.389A3.742,3.742,0,0,0,2.916.728,3.735,3.735,0,0,1,2.129,0,3.735,3.735,0,0,1,0,1.305a3.787,3.787,0,0,0,.787.084Z",
    transform: "translate(14.942 2.914)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.786.9A3.776,3.776,0,0,0,1.657.8V0A3.732,3.732,0,0,1,0,.819,3.777,3.777,0,0,0,.786.9Z",
    transform: "translate(26.61 3.402)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.787,1.389A3.744,3.744,0,0,0,2.917.728,3.735,3.735,0,0,1,2.13,0,3.735,3.735,0,0,1,0,1.306,3.786,3.786,0,0,0,.787,1.389Z",
    transform: "translate(3.276 2.914)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V9.161H1.574V.8A3.737,3.737,0,0,1,0,0Z",
    transform: "translate(0.045 3.402)",
    fill: "#fc8e56",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.787,1.387A3.746,3.746,0,0,0,2.916.728,3.733,3.733,0,0,1,2.129,0,3.733,3.733,0,0,1,0,1.3,3.763,3.763,0,0,0,.787,1.387Z",
    transform: "translate(9.109 2.915)",
    fill: "#fc8e56",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445A1.445,1.445,0,1,1,1.445,2.889,1.444,1.444,0,0,1,0,1.445Z",
    transform: "translate(26.994 16.721)",
    fill: "#fec368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445A1.445,1.445,0,1,1,1.445,2.889,1.444,1.444,0,0,1,0,1.445Z",
    transform: "translate(4.01 16.721)",
    fill: "#fec368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445A1.445,1.445,0,1,1,1.445,2.889,1.444,1.444,0,0,1,0,1.445Z",
    transform: "translate(9.756 16.721)",
    fill: "#fec368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445A1.445,1.445,0,1,1,1.445,2.889,1.444,1.444,0,0,1,0,1.445Z",
    transform: "translate(15.501 16.721)",
    fill: "#fec368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.445A1.445,1.445,0,1,1,1.445,2.889,1.445,1.445,0,0,1,0,1.445Z",
    transform: "translate(21.247 16.721)",
    fill: "#fec368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64,8.044V5.335A2.068,2.068,0,0,1,.357,2.149L1.678.207a.472.472,0,0,1,.781,0l1.32,1.942a2.069,2.069,0,0,1-1.2,3.166V8.044a.472.472,0,1,1-.944,0Z",
    transform: "translate(14.878 0.029)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64,8.044V5.335A2.068,2.068,0,0,1,.357,2.149L1.678.207a.472.472,0,0,1,.781,0l1.32,1.942a2.069,2.069,0,0,1-1.2,3.166V8.044a.472.472,0,1,1-.944,0Z",
    transform: "translate(21.683 0.029)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64,8.044V5.335A2.068,2.068,0,0,1,.357,2.149L1.678.207a.472.472,0,0,1,.781,0l1.32,1.942a2.069,2.069,0,0,1-1.2,3.166V8.044a.472.472,0,1,1-.944,0Z",
    transform: "translate(8.072 0.029)",
    fill: "#d84a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.837,18.293a2.419,2.419,0,0,1-2.37-1.944H1.434a1.445,1.445,0,0,1,0-2.889h.5V2.072A2.048,2.048,0,0,1,3.979.025L30,0h0a2.046,2.046,0,0,1,2.047,2.047V13.46h.5a1.445,1.445,0,0,1,0,2.889H31.513a2.42,2.42,0,0,1-2.371,1.944Z",
    transform: "translate(0 7.603)",
    fill: "#425966"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCake);
export default __webpack_public_path__ + "static/media/ic_cake.c70db41a49993489372dc6abe0656417.svg";
export { ForwardRef as ReactComponent };